import { SortingState } from "@tanstack/react-table";

export const DEFAULT_INITIAL_SORTING: SortingState = [];
export const SORT_DIRECTIONS = { DESC: "DESC", ASC: "ASC" };
